<template>
  <div class="p-hb" :class="navigationSelected365 ? 'wps' : 'solve'">
    <div class="p-hb-bg"></div>
    <div class="p-hb-main">
      <div class="p-hb-box" v-if="baseData">
        <p class="logo" v-if="baseData.logo">
          <img :src="baseData.logo" />
        </p>
        <p class="title">{{ baseData.title }}</p>
        <p class="subtitle">{{ baseData.subtitle }}</p>
        <div class="btn">
          <kd-button
            class="primary-btn"
            @click="downloadClick(baseData.buttonEvent)"
            >{{ baseData.buttonTxt }}</kd-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bannerData365, bannerDataSolve } from '../config';
import { getFromPage, getPageName } from '@/common/utils/index';
import infoCollect from '@/common/infoCollect';
import { getQuery } from '@/common/utils/wpsoffice';
export default {
  name: 'banner-component',
  data() {
    return {
      download365Url: '',
      baseData: bannerData365,
    };
  },
  props: {
    navigationSelected365: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    navigationSelected365: {
      handler: function (val) {
        this.baseData = null;
        setTimeout(() => {
          this.baseData = val ? bannerData365 : bannerDataSolve;
        }, 1);
      },
      immediate: true,
    },
  },
  async mounted() {
    let result = await this.$http({
      method: 'get',
      url: `https://plus.wps.cn/ops/opsd/api/v1/policy?window_key=wps365_download_edu_pc_muti&utm_source=wps&utm_medium=edu_app&from=koa`,
    });
    result?.data?.forEach((element) => {
      if (element.key === 'downloadcontent') {
        const obj = JSON.parse(element.value);
        obj?.forEach((item) => {
          if (item.type === 'pc') {
            const chn = getQuery('chn');
            const link = item.link;
            this.download365Url = link;
            if (chn) {
              this.download365Url =
                this.download365Url +
                (link.indexOf('?') !== -1 ? '&chn=' : '?chn=') +
                chn;
            }
          }
        });
      }
    });
  },
  methods: {
    downloadClick(name) {
      if (this.navigationSelected365) {
        infoCollect.setAppEndExtraData('button_click', name, 'PC', {
          page_name: getPageName(),
          from_item: getFromPage(),
        });
        window.open(this.download365Url, '_self');
      } else {
        this.$emit('homeCallback', {
          dwClickName: name,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.p-hb {
  height: 730px;
  position: relative;
  &.wps {
    padding-top: 119px;
    &::before {
      content: '';
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        #dcf0ff 0%,
        #dff0ff 30%,
        #e7f4ff 60%,
        #ecf4fc 80%,
        #f9fbff 100%
      );
      background-position: 0 0;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      z-index: 0;
      position: absolute;
      top: 0;
    }
  }
  &.solve {
    padding-top: 82px;
    &::before {
      content: '';
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        #c8e8ff 0%,
        #d7eeff 14%,
        #e3f3ff 36%,
        #edf7ff 60%,
        #f8fcff 80%,
        #ffffff 100%
      );
      background-position: 0 0;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      z-index: 0;
      position: absolute;
      top: 0;
    }
    .p-hb-bg {
      background-image: url('~@/assets/images/home/banner-solve.png') !important;
    }
    .logo {
      width: 66px;
      height: 77px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .btn {
      margin-top: 30px;
    }
  }
  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    overflow: hidden;
    background-image: url('~@/assets/images/home/banner-365.png');
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: 1920px auto;
  }

  &-main {
    position: relative;
    z-index: 12;
    width: 1200px;
    height: 282px;
    margin: 0 auto;
  }

  @media screen and (max-width: $width-l) {
    &-main {
      width: 100%;
    }
  }
  &-box {
    height: 100%;
    position: relative;
    text-align: center;
    .logo {
      margin: 0 auto 30px auto;
      width: 215px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      font-size: 48px;
      font-weight: 600;
      line-height: 64px;
      letter-spacing: 6px;
      color: var(--kd-color-text-primary, rgba(13, 13, 13, 0.9));
    }
    .subtitle {
      font-size: 16px;
      line-height: 22px;
      color: var(--kd-color-text-secondary, rgba(13, 13, 13, 0.66));
      margin-top: 12px;
    }
    .btn {
      margin-top: 30px;
      button {
        width: 240px;
        height: 54px;
        font-weight: 600;
        font-size: 18px;
        line-height: 54px;
      }
      button + button {
        margin-left: 16px;
      }
    }
  }
}
</style>
